import {Component, OnDestroy, OnInit} from '@angular/core';
import {DropdownService} from "../service/dropdown.service";
import {PaymentType} from "../layouts/payment-type/payment-type";
import {ShoppingSharedService} from "../service/shopping-shared.service";
import {ShippingType} from '../enums/ShippingType';
import {ShippingUtility} from "../utilityClass/shippingUtility";
import {Router} from "@angular/router";
import {CreditCardResponse} from "../models/creditCardResponse";
import {CreditCardService} from "../service/credit-card.service";
import {CartItemRequest} from "../models/cartItemRequest";
import {QuickOrderRequest} from "../models/quickOrderRequest";
import {OrderRequest} from "../models/orderRequest";
import {ShippingAddressRequest} from "../models/shippingAddressRequest";
import {Location} from "@angular/common";
import {InitPaymentRequest} from "../models/payment/initPaymentRequest";
import {InitPaymentResponse} from "../models/payment/initPaymentResponse";
import {AMERIA_FORM, PAYMENT_ID_NAME} from "../constants/payment.constant";
import {UserService} from "../service/user.service";
import {AttributeValueResponse} from "../models/attributeValueResponse";
import {DiscountResponse} from "../interface/discountResponse";
import {Order} from "../models/Order";
import {OrdersService} from "../service/orders.service";
import {TelcellService} from "../service/telcell.service";
import {IdramService} from "../service/idram.service";
import {MyPayService} from "../service/my-pay.service";
import {EasywalletService} from "../service/easywallet.service";
import {FastshiftService} from "../service/fastshift.service";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {HttpErrorResponse} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-product-payment',
  templateUrl: './product-payment.component.html',
  styleUrls: ['./product-payment.component.scss', '../shipping-address/order-summary/order-summary.component.scss']
})
export class ProductPaymentComponent implements OnInit,OnDestroy {

  protected isDropdownOpened: boolean = false;

  protected selectedPaymentType: PaymentType = PaymentType.CREDIT_CARD;
  protected isBillingAddressSame: boolean = true;
  protected currentUserId: bigint | null = null;

  formData: any = null;
  products: any[] = [];
  totalSumAmd!: number;
  totalSumUsd!: number;
  calculatedSumAmd!: number;
  calculatedSumUsd!: number;

  selectedDeliveryMethod: ShippingType = ShippingType.STANDARD;

  deliveryAddress = '';

  creditCards: Array<CreditCardResponse> = [];
  selectedCreditCard: CreditCardResponse | null | undefined;
  isPayClicked: boolean = false;

  constructor(
    private dropdownService: DropdownService,
    private shoppingSharedService: ShoppingSharedService,
    private router: Router,
    private creditCardService: CreditCardService,
    private orderService: OrdersService,
    private location: Location,
    private userService: UserService,
    private telcell: TelcellService,
    private idram: IdramService,
    private easywalletService: EasywalletService,
    private myPayService: MyPayService,
    private fastshiftService: FastshiftService,
    private snackBar: SnackBarUtil,
    private translate: TranslateService
  ) {
    this.initCurrentUser();
  }

  ngOnInit() {
    this.formData = this.shoppingSharedService.formData;
    this.products = this.shoppingSharedService.products;
    this.totalSumAmd = this.shoppingSharedService.totalSumAmd;
    this.totalSumUsd = this.shoppingSharedService.totalSumUsd;
    this.calculatedSumAmd = this.totalSumAmd;
    this.calculatedSumUsd = this.totalSumUsd;
    this.selectedDeliveryMethod = this.shoppingSharedService.shippingType;

    if (!this.products.length) {
      this.router.navigate(['/cart']);
      return;
    }

    if (!this.formData && this.selectedDeliveryMethod !== ShippingType.PICKUP) {
      this.router.navigate(['/shipping-method']);
      return;
    }

    this.getAllCreditCards();
    if (this.formData) {
      this.deliveryAddress = this.buildAddressString(this.shoppingSharedService.formData);
    }
  }

  ngOnDestroy() {
    this.selectedPaymentType = PaymentType.CREDIT_CARD;
    this.isBillingAddressSame = true;
  }

  protected pay(): void {
    if (this.isPayClicked) {
      return;
    }
    this.isPayClicked = true;

    let shippingAddressRequest: ShippingAddressRequest;
    if (this.selectedDeliveryMethod === ShippingType.PICKUP) {
      shippingAddressRequest = new ShippingAddressRequest(null, '', '', '', '', '', false);
    } else if (this.shoppingSharedService.formData) {
      const {country, address, apartment, postalCode, city, rememberAddress} = this.shoppingSharedService.formData;
      shippingAddressRequest = new ShippingAddressRequest(null, country, address, apartment, postalCode, city, rememberAddress);
    } else {
      this.router.navigate(['/shipping-method']);
      this.isPayClicked = false;
      return;
    }

    if (this.hasShippingAddress) {
      if (this.selectedPaymentType !== PaymentType.CREDIT_CARD &&
          this.selectedPaymentType !== PaymentType.EXISTING_CREDIT_CARD) {
        this.isPayClicked = false;
        this.selectedPaymentType = PaymentType.CREDIT_CARD;
        this.selectedCreditCard = null;
        return;
      }
    }

    if (this.products[0]?.shoppingCartId == null) {
      this.quickShop(shippingAddressRequest);
    } else {
      this.order(shippingAddressRequest);
    }
  }

  protected return() {
    if (this.selectedDeliveryMethod === ShippingType.PICKUP) {
      this.router.navigate(['/shipping-method']);
    } else if (this.formData && this.deliveryAddress) {
      this.router.navigate(['/shipping-address'], {
        state: {
          formData: this.formData,
          shopData: this.products,
          totalSumAmd: this.totalSumAmd,
          totalSumUsd: this.totalSumUsd,
        },
      });
    } else {
      this.router.navigate(['/shipping-method']);
    }
  }

  protected handleApplyPromoCode(discountResponse: DiscountResponse) {
    this.calculatedSumAmd = discountResponse.price;
    this.calculatedSumUsd = this.totalSumUsd - this.totalSumUsd * discountResponse.percent / 100;
  }

  protected clickOnDropdown(dropdownDiv: HTMLDivElement) {
    this.dropdownService.process(dropdownDiv, this.isDropdownOpened);
    this.isDropdownOpened = !this.isDropdownOpened;
  }

  protected truncateText(value: string, limit: number): string {
    if (value.length <= limit) {
      return value;
    }
    return value.substring(0, limit) + '...';
  }

  protected selectType(type: PaymentType, creditCard?: CreditCardResponse) {
    if (creditCard) {
      this.selectedCreditCard = creditCard;
    } else {
      this.selectedCreditCard = null;
    }
    this.selectedPaymentType = type;
  }

  private getAllCreditCards() {
    this.creditCardService.getAll().subscribe({
      next: (creditCard: Array<CreditCardResponse>) => {
        this.creditCards = creditCard;
      }
    })
  }

  private buildAddressString(contactForm: any): string {
    const {country, address, apartment, postalCode, city} = contactForm;

    let fullAddress = `${country}, ${city}, ${address}, ${postalCode}, ${apartment}`;

    fullAddress = fullAddress
      .split(', ')
      .filter(part => part && part.trim().length > 0)
      .join(', ');

    return fullAddress;
  }

  private initCurrentUser() {
    const email = this.userService.email;
    if(email) {
      this.userService.findByEmail(email).subscribe(user => {
        this.currentUserId = user.id;
      });
    }
  }

  private order(shippingAddressRequest: ShippingAddressRequest) {
    const shoppingCartId = this.products[0]?.shoppingCartId;
    const orderRequest = new OrderRequest(shoppingCartId, this.shoppingSharedService.promoCode, this.selectedDeliveryMethod, this.totalSumAmd, shippingAddressRequest, null);
    this.orderService.create(orderRequest).subscribe({
      next: (response: Order) => {
        this.handleSelectedPaymentType(response);
      },
      error: (error: HttpErrorResponse) => {
        this.isPayClicked = false;
        let errorMessage = error.error?.message || error.error || 'An error occurred while creating the order.';
        if (errorMessage.includes('Cannot purchase Standard Subscription Activation product')) {
          errorMessage = this.translate.instant('subscription_plan_content.cannot_purchase_subscription_activation');
        }
        this.showSnackbar(MockupDataModel.error(errorMessage), SnackBarUtil.CLASSES.error);
      }
    })
  }

  private quickShop(shippingAddressRequest: ShippingAddressRequest) {
    const idOfSelectedAttribute: number = (this.products[0].product.attributeValues as Array<AttributeValueResponse>)
      .find(attributeValue => attributeValue.value == this.products[0].selectedColor)!
      .id;

    const itemRequest = new CartItemRequest(this.products[0].product.id, this.products[0].quantity, Array.of(idOfSelectedAttribute), true)
    const quickOrderRequest = new QuickOrderRequest(Array.of(itemRequest), this.shoppingSharedService.promoCode, this.shoppingSharedService.shippingType, this.shoppingSharedService.totalSumAmd, shippingAddressRequest, null);
    this.orderService.quickOrder(quickOrderRequest).subscribe({
      next: (response: Order) => {
        this.handleSelectedPaymentType(response);
      },
      error: (error: HttpErrorResponse) => {
        this.isPayClicked = false;
        let errorMessage = error.error?.message || error.error || 'An error occurred while creating the order.';
        // Check if it's the subscription activation error and translate it
        if (errorMessage.includes('Cannot purchase Standard Subscription Activation product')) {
          errorMessage = this.translate.instant('subscription_plan_content.cannot_purchase_subscription_activation');
        }
        this.showSnackbar(MockupDataModel.error(errorMessage), SnackBarUtil.CLASSES.error);
      }
    })
  }

  private handleSelectedPaymentType(response: Order) {
    switch (this.selectedPaymentType) {
      case PaymentType.CREDIT_CARD:
        this.payWithNewCreditCard(response);
        break;
      case PaymentType.EXISTING_CREDIT_CARD:
        this.payWithExistingCreditCard(response);
        break;
      case PaymentType.TELCELL:
        this.payWithTelcell(response);
        break;
      case PaymentType.IDRAM:
        this.payWithIdram(response);
        break;
      case PaymentType.EASY_WALLET:
        this.payWithEasyWallet(response);
        break;
      case PaymentType.MY_PAY:
        this.payWithMyPay(response);
        break;
      case PaymentType.FASTSHIFT:
        this.payWithFastshift(response);
        break;
      default:
        this.isPayClicked = false;
    }
  }

  private payWithNewCreditCard(order: Order) {
    const opaque = JSON.stringify({"scanMeOrderId": order.id, "currentUserId": this.currentUserId});
    const request = InitPaymentRequest.initForProductBuying(this.totalSumAmd, "", opaque, this.shoppingSharedService.promoCode, order.id);
    this.orderService.process(request).subscribe({
      next: (response: InitPaymentResponse) => {
        window.location.href = AMERIA_FORM.replaceAll(PAYMENT_ID_NAME, response.PaymentID);
      },
      complete: () => {
        this.isPayClicked = false;
      }
    });
  }

  private payWithExistingCreditCard(order: Order) {
    if(!this.selectedCreditCard) return;
    const request = InitPaymentRequest.initForProductBuying(this.totalSumAmd, this.selectedCreditCard.cardHolderId, "{}", this.shoppingSharedService.promoCode, order.id);
    this.orderService.buyWithExistingCard(request).subscribe({
      next: (response: Order) => {
        this.router.navigate(['payment/receipt'], {
          queryParams: {
            paymentError: 'false',
            orderResponse: response.id
          }
        })
      },
      error: () => {
        this.router.navigate(['payment/receipt'], {
          queryParams: {
            paymentError: 'true'
          }
        })
      },
      complete: () => {
        this.isPayClicked = false;
      }
    });
  }

  private payWithTelcell(response: Order) {
    this.telcell.initForProductBuying(response.totalAmount, response.id);
    this.isPayClicked = false;
  }

  private payWithIdram(response: Order) {
    this.idram.initForProductBuying(response.totalAmount, response.id);
    this.isPayClicked = false;
  }

  public payWithEasyWallet(response: Order) {
    this.easywalletService.initForProductBuying(response.totalAmount, response.id);
    this.isPayClicked = false;
  }

  private payWithMyPay(response: Order) {
    this.myPayService.initForProductBuying(response.totalAmount, response.id);
    this.isPayClicked = false;
  }

  public payWithFastshift(response: Order) {
    this.fastshiftService.initForProductBuying(response.totalAmount, response.id);
    this.isPayClicked = false;
  }

  protected readonly PaymentType = PaymentType;
  protected readonly ShippingType = ShippingType;

  getShippingMethodName(): string {
    return ShippingUtility.getShippingMethodName(this.selectedDeliveryMethod);
  }

  get hasShippingAddress(): boolean {
    return !!this.formData && this.selectedDeliveryMethod !== ShippingType.PICKUP;
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBar.openSnackBar({
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      data: data,
      panelClass: panelClassNames
    });
  }
}
